export default "__VITE_ASSET__CY5iIUp7__"